import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { standardFocusState } from 'approot/shared/styles/borders.style';
import { grey5, grey7, purple7 } from 'approot/shared/styles/colours.style';
import { spacing4, spacing8 } from 'approot/shared/styles/spacing.style';
import { skeletonState } from 'approot/shared/styles/transitions.style';
import { flexCentreAlignCss } from 'approot/shared/styles/flex.style';
import { PStyled } from 'approot/shared/styles/typography.style';
import { SettingsComponentMenuInner } from 'approot/activity-builder/settings/settings-component-menu.style';

export const ComponentHeightWrapper = styled.div`
  position: relative;
`;

type ComponentInnerWrapperProps = {
  $isLoading?: boolean;
};
export const ComponentInnerWrapper = styled.div<ComponentInnerWrapperProps>`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;

  display: flex;
  flex-direction: column;

  ${({ $isLoading }) =>
    $isLoading &&
    `
    &:before {
      ${skeletonState}
      background-color: rgba(255,255,255,0.8);
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;
      z-index: 10;
    }
  `}
`;

export const ComponentHeightBottomHandle = styled.button`
  ${standardFocusState}

  background-color: ${grey5};
  border-radius: ${rem(72)};
  border: none;
  display: block;
  cursor: ns-resize;
  height: ${rem(8)};
  left: 50%;
  margin: 0;
  margin-left: -${rem(40)};
  padding: 0;
  position: absolute;
  bottom: -${rem(spacing4)};
  width: ${rem(80)};
  z-index: 10;

  &:hover,
  &:active {
    background-color: ${purple7};
  }
`;

export const ComponentAspectRatio = styled.div`
  height: 100%;
  position: relative;
`;

type ComponentAbsoluteWrapperProps = {
  $centred?: boolean;
};

export const ComponentAbsoluteWrapper = styled.div<
  ComponentAbsoluteWrapperProps
>`
  ${({ $centred = true }) => $centred && flexCentreAlignCss}

  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;

export const ComponentHeightValue = styled(PStyled)`
  margin: 0 ${rem(spacing8)};
  color: ${grey7};
  white-space: nowrap;
`;

export const ComponentHeightStepWrapper = styled(SettingsComponentMenuInner)`
  ${flexCentreAlignCss}
  margin-right: ${rem(spacing4)};
`;
